module.exports = __webpack_public_path__ + "img/tarj-gib.e31c3f15.jpg";